import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: 100%;
`;

export const Options = styled.div`
  flex: 1;
  padding: 1rem 0.3rem 1rem 0;
  flex-wrap: wrap;
  border-right: solid 2px;
  border-color: ${({ theme }) => theme.colors.tertiary_500};

  button {
    display: flex;
    gap: 0.5rem;
    font-size: 1.2rem;
    font-weight: 300;
    color: ${({ theme }) => theme.colors.tertiary_500};
    align-items: center;
    justify-content: flex-start;
    text-transform: none;
    height: 2rem;
    border-radius: 0.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;

    .icons {
      width: 20px;
      height: 22px;
      color: ${({ theme }) => theme.colors.tertiary_500};
      fill: ${({ theme }) => theme.colors.tertiary_500};
      stroke: ${({ theme }) => theme.colors.tertiary_500};
      
    }

    svg {
      font-size: 24px;
    }
  }

  div {
    svg {
      color: ${({ theme }) => theme.colors.tertiary_500};
      fill: ${({ theme }) => theme.colors.tertiary_500};
    }

    display: flex;
    align-items: center;
    padding: 0.3rem 0;
  }

  .Link {
    transition: 0.2s;
    &:hover {
      opacity: 0.5;
    }
  }

  @media (max-width: 1200px) {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 0;
    gap: 0.8rem;
    border-right: none;
    border-bottom: solid 2px;
    border-color: ${({ theme }) => theme.colors.tertiary_500};

    button {
      .icons {
        width: 18px;
        height: 20px;
      }

      svg {
        font-size: 22px;
      }
    }
  }
`;
